<script type="text/jsx">
import SkeletonAvatar from './avatar.vue'
import SkeletonContent from './content.vue'
import { PREFIX_CLASS } from '../../utils/constants'
const PREFIX_SKELETON_CLASS = `${PREFIX_CLASS}skeleton`

export default {
  name: 'TSkeleton',
  components: {
    SkeletonAvatar,
    SkeletonContent
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    skeletonList: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    avatar: {
      type: [Object, String],
      default: null
    },
    paragraph: {
      type: Boolean,
      default: true
    },
    title: {
      type: Boolean,
      default: true
    },
    rows: {
      type: Number,
      default: 3
    }
  },
  computed: {
    classes() {
      return [
        `${PREFIX_SKELETON_CLASS}`,
        {
          [`${PREFIX_SKELETON_CLASS}-active`]: this.active,
          [`${PREFIX_SKELETON_CLASS}-with-avatar`]: Object.prototype.toString.call(this.avatar) === '[object Object]',
          [`${PREFIX_SKELETON_CLASS}-list`]: this.skeletonList
        }
      ]
    }
  },
  render() {
    let rows = new Array(this.rows).fill(1)
    let component = (
      <div class={this.classes}>
        {Object.prototype.toString.call(this.avatar) === '[object Object]' ? <skeleton-avatar avatar={this.avatar}></skeleton-avatar> : ''}
        <skeleton-content paragraph={this.paragraph} title={this.title}>
          {
            rows.map(v => {
              return <li></li>
            })
          }
        </skeleton-content>
      </div>
    )
    // this.$scopedSlots.default() 和 this.$slots.default都是获取插槽的内容
    if (this.loading) {
      return component
    } else {
      return (
        <div>{this.$slots.default}</div>
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/skeleton/skeleton.vue